/**
 * @description
 * Error used when an operation is not performed because there is no connectivity.
 *
 * Allows distinguishing "not sent to the backend because we were offline" from a
 * real backend failure, so callers can react accordingly (e.g. keep showing the
 * data already loaded instead of treating it as an error).
 */
export class OfflineError extends Error {
  constructor(message = 'There is no connectivity: the operation was not sent to the backend.') {
    super(message);
    this.name = 'OfflineError';
  }
}
